import clsx from 'clsx';
import React from 'react';

import useDualOfferFunctionality from '@hooks/useDualOfferFunctionality';
import { OfferOption, SelectedOffer } from '@utils/backend-api/subscribe';

import CorporateInquiry from './CorporateInquery';
import HorizontalOffer from './HorizontalOffer';
import VerticalOffer from './VerticalOffer';

interface ContentProps {
  defaultSelectedOffer: SelectedOffer;
  offers: OfferOption[];
}

const Content = ({ defaultSelectedOffer, offers }: ContentProps) => {
  const { horizontalOffers, isMobile, midPoint, selectedOffer, setSelectedOffer, verticalOffers } =
    useDualOfferFunctionality({ defaultSelectedOffer, offers });

  return (
    <div className="px-16 sm:px-28" data-testid="dual-subscribe-multiple-offers">
      <div className="md:max-w relative mx-auto w-full sm:max-w-[1040px] xl:max-w-[1130px]">
        <div className="mb-64 flex max-w-full flex-col-reverse flex-wrap sm:flex-row">
          <div
            className="absolute left-[50%] z-10 h-[25px] w-[25px] -translate-x-1/2 -translate-y-1/2 rotate-45 bg-grayscale-beige md:h-[35px] md:w-[35px]"
            style={isMobile ? { top: midPoint } : { top: '45px' }}
          ></div>
          {verticalOffers.map((offer, index) => (
            <VerticalOffer
              presentedOffers={offers}
              key={index}
              offer={offer}
              isOfferSelected={selectedOffer.code === offer.code}
              isMobile={isMobile}
              setSelectedOffer={setSelectedOffer}
              className={clsx(
                'border border-b border-l border-r border-solid border-grayscale-beige',
                {
                  'border-r-transparent': index % 2 === 0,
                  'border-l-transparent ': index % 2 !== 0,
                }
              )}
            />
          ))}
        </div>
        {horizontalOffers.length > 0 && (
          <div className="flex flex-col items-center justify-center">
            <div className="mb-16 font-suisse-screen text-headline-xxs">See more subscriptions</div>
            {horizontalOffers.map((offer, index) => (
              <div
                id={offer.code}
                key={index}
                className={clsx(
                  'relative flex w-full flex-wrap items-center justify-between gap-16 border border-l-0 border-r-0 border-t border-solid bg-white px-16 py-24 md:w-[836px] md:gap-90 md:px-48',
                  {
                    'border-b': index === horizontalOffers.length - 1,
                    'border-b-0': index !== horizontalOffers.length - 1,
                  }
                )}
              >
                <HorizontalOffer offer={offer} />
              </div>
            ))}
          </div>
        )}
        <CorporateInquiry />
      </div>
    </div>
  );
};

export default Content;
